import { withMeetingBasedMarketTemplateModelState } from '@swf/sports/models/market-templates/meetingBased';

import type { SportsRacePageState } from './types';

export const defaultState = withMeetingBasedMarketTemplateModelState<SportsRacePageState>({
  isLoading: true,
  hasPreloaded: false,
  groups: [],
  timeformRunners: []
});
